module.exports = __webpack_public_path__ + "img/icon-human.154b38b6.png";